/**
 * Formatea un timestamp de Firestore a fecha legible
 */
export const formatDate = (
  timestamp: { _seconds: number; _nanoseconds: number } | undefined | null
): string => {
  if (!timestamp || !timestamp._seconds) return "N/A";
  const date = new Date(timestamp._seconds * 1000);
  return date.toLocaleDateString("es-ES", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

/**
 * Formatea una coordenada a 4 decimales
 */
export const formatCoordinate = (coord: string | number): string => {
  return parseFloat(coord as string).toFixed(4);
};

/**
 * Formatea el área en metros cuadrados
 */
export const formatArea = (area: number): string => {
  if (area >= 1000000) {
    return `${(area / 1000000).toFixed(2)} km²`;
  }
  return `${area.toFixed(0)} m²`;
};

/**
 * Formatea la distancia en metros o kilómetros
 */
export const formatDistance = (distance: number): string => {
  if (distance >= 1000) {
    return `${(distance / 1000).toFixed(2)} km`;
  }
  return `${distance.toFixed(0)} m`;
};
